(function () {
  'use strict';

  window.__kirkGemistAllowWithoutDiamond = false;
  var latestSelection = null;

  window.addEventListener('gemist:diamond-selection-changed', function (event) {
    latestSelection = event.detail || null;
  });

  function selectionIsActive(selection) {
    if (!selection) return false;
    if (selection.selected) return true;
    return Boolean(selection.diamond);
  }

  function diamondSelected() {
    var live = window.gemistStoneMarketplace && window.gemistStoneMarketplace.selection;
    if (selectionIsActive(live)) return true;
    return selectionIsActive(latestSelection);
  }

  window.__kirkGemistDiamondSelected = diamondSelected;

  function openPopup() {
    var popup = document.querySelector('.wwyldn');
    if (!popup) return;
    popup.style.setProperty('display', 'flex', 'important');
  }

  function isCartAdd(input) {
    var url = '';
    if (typeof input === 'string') url = input;
    else if (input && typeof input.url === 'string') url = input.url;
    return url.indexOf('/cart/add') !== -1;
  }

  function shouldBlockCartAdd(input) {
    if (!isCartAdd(input)) return false;
    if (window.__kirkGemistAllowWithoutDiamond) return false;
    if (diamondSelected()) return false;
    return true;
  }

  function installFetchGuard() {
    if (window.fetch && window.fetch.__kirkGemistGuard) return;
    var next = window.fetch;
    function guarded(input, init) {
      if (shouldBlockCartAdd(input)) {
        openPopup();
        return Promise.reject(new Error('kirk-gemist-choose-next'));
      }
      return next.apply(this, arguments);
    }
    guarded.__kirkGemistGuard = true;
    window.fetch = guarded;
  }

  function isPopupSubmit(event) {
    return Boolean(event.target && event.target.closest && event.target.closest('.wwyldn'));
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest('.wwyldn button[name="add"], .wwyldn button[type="submit"]')) {
        window.__kirkGemistAllowWithoutDiamond = true;
        return;
      }

      var addBtn = event.target.closest('button.add-to-bag-button[name="add"]');
      if (!addBtn || addBtn.closest('.wwyldn')) return;
      if (diamondSelected()) return;
      if (window.__kirkBuilderDiamondSelected && window.__kirkBuilderDiamondSelected()) {
        event.preventDefault();
        event.stopPropagation();
        if (window.__kirkAddRingWithBuilderDiamond) window.__kirkAddRingWithBuilderDiamond(addBtn);
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      openPopup();
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      if (!event.target || !event.target.closest) return;
      if (!event.target.closest('product-form')) return;

      if (isPopupSubmit(event) || (event.submitter && event.submitter.closest('.wwyldn'))) {
        window.__kirkGemistAllowWithoutDiamond = true;
        return;
      }

      if (diamondSelected()) return;
      if (window.__kirkBuilderDiamondSelected && window.__kirkBuilderDiamondSelected()) {
        event.preventDefault();
        event.stopPropagation();
        if (window.__kirkAddRingWithBuilderDiamond) window.__kirkAddRingWithBuilderDiamond();
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      openPopup();
    },
    true
  );

  installFetchGuard();

  var observer = new MutationObserver(function () {
    installFetchGuard();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  var tries = 0;
  var timer = setInterval(function () {
    installFetchGuard();
    tries += 1;
    if (tries > 40) clearInterval(timer);
  }, 500);
})();
